import "./Projects.css";

const About = () => {
  return (
    <div id="aboutMeSection" className="portfolio-project-section">
      <h1 className="portfolio-project-header">About Me</h1>
      <h3 className="portfolio-project-block">
        I'm a self-taught full-stack developer with no previous coding
        background. I've built many projects using React.js, Node.js, MySQL, and
        more. I'm constantly enhancing my skills and exploring new technologies.
        When I'm not coding, you'll find me socializing at my favorite coffee
        shop, practicing Brazilian Jiu-Jitsu, or hanging out with friends on
        Discord.
      </h3>
    </div>
  );
};

export default About;
